import React from 'react';

import { Button } from 'react-bootstrap';
import { OptimizedImage } from '../common/OptimizedImage';
import { navigate } from '@reach/router';

const SectionBanner = () => {
  return (
    <div className="section-banner pos-rel">
      <div className="section-bg-wrapper">
        <OptimizedImage fileName="home_block.jpg" />
      </div>
      <div className="container-fluid">
        <div className="text-center-wrapper">
          <h2 className="petcare-img-oh">NZ made dog food shouldn’t cost the earth.</h2>
          <div className="row">
            <div className="col-1">&nbsp;</div>
            <div className="col-10" style={{ textAlign: 'center' }}>
              <p>
                Feed My Furbaby is absolutely committed to being the most
                sustainable pet care company, bar none! <br />
                We believe that making it easier for us all to be concious pet
                parents is the best way to reduce our pet’s impact on our
                planet.
              </p>
            </div>
          </div>

          <Button
            className="btn-txt btn-txt-org"
            onClick={() => {
              navigate('/ourstory');
            }}
          >
            Learn about our story
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SectionBanner;
